<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <!------------ START TABELA LIST FECHAMENTO------------>
    <vs-table
      v-if="mostrarFechamentos"
      noDataText="Nenhuma Fechamento Encontrada"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="itensFiltred"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="perfis.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium"
            >
              <span class="mr-2">Filtrar por: {{ ultimoFiltro }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="filtrar('Em Aberto')">
                <span>Todos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Em Aberto')">
                <span>Em Aberto</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Processando')">
                <span>Processando</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Finalizado')">
                <span>Finalizado</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Com Falha')">
                <span>Com Falha</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ START ADD NOVO Perfil ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary"
            @click="opemModalInsertEdit({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Fechamento</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Perfil ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itensFiltred.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itensFiltred.length
              }}
              de {{ itensFiltred.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>
      <template slot="thead">
        <vs-th sort-key="Nome">ID</vs-th>
        <vs-th sort-key="Nome">Criado em</vs-th>
        <vs-th sort-key="Nome">Mês Referencia Cobrança</vs-th>
        <vs-th sort-key="Nome">Vencimentos</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START BODY DA TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.id }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ formataData(tr.createdAt) }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.mes_referencia_cobranca }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.vencimentos_apolices }}</p>
            </vs-td>
            <td>
              <vs-chip v-if="tr.badge" :color="tr.badge.COR" class="product-order-status">{{
                tr.badge.STATUS
              }}</vs-chip>
            </td>

            <vs-td>
              <p class="product-price">
                <vs-button
                  v-tooltip="'Editar'"
                  radius
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="opemModalInsertEdit(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
              </p>

              <p class="product-price">
                <vs-button
                  v-tooltip="'Ver Detalhes'"
                  radius
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="d-inline"
                  @click="prepararVerCobrancas(tr.cobrancas)"
                ></vs-button>
                <router-link
                  v-if="tr.dataFinalizacao"
                  target="_blank"
                  :to="`arquivoImpressao/${tr.idRateio}`"
                >
                  <vs-button
                    v-tooltip="'Arquivo de Impressao'"
                    radius
                    color="warning"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-printer"
                    class="d-inline"
                  ></vs-button>
                </router-link>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
      <!------------ END BODY DA TABELA ------------>
    </vs-table>
    <!-------------- END TABELA LIST FECHAMENTO-------------->

    <!-------------- START TABELA LIST COBRANCAS ------------>
    <vs-table
      v-if="mostrarCobrancas"
      noDataText="Nenhuma Cobranca Encontrada"
      class="tablePrincipal"
      ref="tablecobrancas"
      pagination
      :max-items="itemsPerPageCobrancas"
      :data="cobrancasFiltradas"
    >
      <div slot="header" class="flex flex-grow items-start">
        <vs-button
          color="primary"
          type="border"
          class="mr-4 mt-1"
          @click="voltarFechamentos"
          >Voltar</vs-button
        >

        <!------------ START FILTOS ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
          <div
            class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium"
          >
            <span class="mr-2">Filtrar por: {{ ultimoFiltro }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="alterarFiltroCobrancas('Todas')">
              <span>Todas</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="alterarFiltroCobrancas('Criado')">
              <span>Criado</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="alterarFiltroCobrancas('Processando')">
              <span>Processando</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="alterarFiltroCobrancas('Gerada')">
              <span>Gerada</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="alterarFiltroCobrancas('Erro')">
              <span>Erro</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!------------ END FILTROS ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{
                currentPageCobrancas * itemsPerPageCobrancas -
                (itemsPerPageCobrancas - 1)
              }}
              -
              {{
                cobrancasFiltradas.length -
                  currentPageCobrancas * itemsPerPageCobrancas >
                0
                  ? currentPageCobrancas * itemsPerPageCobrancas
                  : cobrancasFiltradas.length
              }}
              de {{ cobrancasFiltradas.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPageCobrancas = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPageCobrancas = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPageCobrancas = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPageCobrancas = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!------------ END ITENS POR PÁGINA ------------>
      </div>

      <!------------ START TITULO DA TABELA -------------->
      <template slot="thead">
        <vs-th sort-key="apolice_id">N° Apólice</vs-th>
        <vs-th sort-key="pagamento">Pagamento</vs-th>
        <vs-th sort-key="status_apolice">Status da Cobrança</vs-th>
        <vs-th sort-key="apolice">Apólice</vs-th>
        <vs-th sort-key="segurado">Segurado</vs-th>
        <vs-th sort-key="valor">Valor</vs-th>
        <vs-th>Data Vencimento</vs-th>
        <vs-th>Parcela</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ----------------->

      <!------------ START BODY DA TABELA ----------------->
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.apolice_id }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.pagamento }}</p>
            </vs-td>
            <td>
              <vs-chip
                v-if="tr.badge"
                :color="tr.badge.COR"
                class="product-order-status"
                >{{ tr.badge.STATUS }}</vs-chip
              >
            </td>
            <vs-td>
              <p class="product-category">{{ tr.apolice }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.segurado }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.valor | currency }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.vencimento }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.parcela }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
      <!------------ END BODY DA TABELA ------------------->
    </vs-table>
    <!-------------END TABELA LIST COBRANCAS -------------->

    <!------------ START INFORMAÇÕES DO Perfil ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados do ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <Modal
      class="holamundo"
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="buscarFechamentos"
    >
      <FormRateio :dados="dadosSideBar" @concluido="concluido"></FormRateio>
    </Modal>

    <!------------ END INFORMAÇÕES DO Perfil ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import service from '../../../../services';
import downloadexcel from 'vue-json-excel';
import ModalInfo from './../../../../components/ModalInfo.vue';
import FormRateio from './FormFechamento.vue';
import jwt from 'jsonwebtoken';
import notify from '../../../../utils/notify';
import functions from '../../../../utils/functions';
import Modal from '../../../../components/Modal.vue';

export default {
  components: {
    downloadexcel,
    ModalInfo,
    FormRateio,
    Modal
  },
  props: ['subjectPermission'],
  data() {
    return {
      formataData: functions.formataDataMomentJS,
      idEmpresa: null,
      modalForm: false,
      dadosSideBar: {},
      controllerGeral: 'Rateios',
      formSideBar: 'Rateios',
      entidade: 'Rateios',
      titleSideBar: 'Adicionar Fechamento',
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      itensFiltred: [],
      cobrancas: [],
      cobrancasFiltradas: [],
      filtroCobrancas: 'Todas',
      listar: 'fechamentos',
      colunas: {},
      itemsPerPage: 10,
      itemsPerPageCobrancas: 10,
      isMounted: false,
      ultimoFiltro: 'Todos',
      decoded: null,
      idUsuario: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted && this.$refs.table) {
        return this.$refs.table.currentx;
      }
      return 1;
    },
    currentPageCobrancas() {
      if (this.$refs.tableCobrancas) {
        return this.$refs.tableCobrancas.currentx;
      }
      return 1;
    },
    mostrarFechamentos() {
      return this.listar === 'fechamentos';
    },
    mostrarCobrancas() {
      return this.listar === 'cobrancas';
    },
  },
  methods: {
    voltarFechamentos() {
      this.listar = 'fechamentos';
    },
    prepararVerCobrancas(cobrancas) {
      this.cobrancas = cobrancas;
      this.aplicarFiltroCobrancas();
      this.listar = 'cobrancas';
    },
    alterarFiltroCobrancas(filtro) {
      this.filtroCobrancas = filtro;
      this.aplicarFiltroCobrancas();
    },
    aplicarFiltroCobrancas() {
      if (this.filtroCobrancas === 'Todas') {
        this.cobrancasFiltradas = this.cobrancas;
        return;
      }

      this.cobrancasFiltradas = this.cobrancas.filter(
        (c) => c.status_cobranca === this.filtroCobrancas,
      );
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    filtrar(filtro) {
      this.ultimoFiltro = filtro;

      if (filtro == 'Todos') {
        this.itensFiltred = this.itens;
        return;
      }

      this.itensFiltred = this.itens.filter((i) => i.status === filtro);
    },
    closeModais() {
      this.modalForm = false;
    },
    async buscarFechamentos() {
      try {
        this.$vs.loading();
        const { data } = await service.getAll('Fechamentos', null, 'list');
        this.itens = [];
        this.itens = data;
        this.filtrar(this.ultimoFiltro);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    opemModalInsertEdit(dados) {
      this.titleSideBar = `Editar dados do  Fechamento`;
      this.dadosSideBar = dados;
      this.modalForm = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idCarteira == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.modalForm = false
      this.buscarFechamentos();
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');

      if (token) {
        this.decoded = jwt.decode(token);
      }

      this.idUsuario = this.decoded.id_usuario;
      this.idEmpresa = this.decoded.id_empresa;
    },
  },
  created() {
    this.getDecoded();
  },
  mounted() {
    this.buscarFechamentos();
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style>
.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
<!------------ END STYLE ------------>
